export function addOrRemoveString(arr: string[], item: string): string[] {
  const filtered = arr.filter(el => el !== item);

  if (filtered.length === arr.length) {
    return [...arr, item];
  }

  return filtered;
}
